module.exports = __webpack_public_path__ + "static/media/plan_edit.f90d889c.svg";